module.exports = __webpack_public_path__ + "img/bg-ai-stars.0630c27.webp";